import { defineStore } from 'pinia';

export const useSnackbarStore = defineStore('snackbar', {
    state: () => ({
        open: false,
        text: '',
        color: 'red',
    }),

    actions: {
        show(text, color = 'red') {
            this.text = text;
            this.color = color;
            this.open = true;
        },
        close() {
            this.open = false;
        },
    },
});
